// src/frontend/src/pages/PaymentCancelled.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout/Layout';

const PaymentCancelled: React.FC = () => {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto text-center py-16">
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Payment Cancelled
        </h1>
        
        <p className="text-xl text-gray-600 mb-8">
          No worries! Your subscription wasn't processed. You can try again anytime.
        </p>

        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-8">
          <h3 className="font-semibold text-gray-900 mb-2">Need Help?</h3>
          <p className="text-gray-700 text-sm">
            If you're experiencing issues with payment or have questions about our plans, 
            we're here to help.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/pricing"
            className="bg-blue-600 text-white px-8 py-3 rounded-md hover:bg-blue-700 transition-colors"
          >
            Try Again
          </Link>
          <Link
            to="/contact"
            className="border border-gray-300 text-gray-700 px-8 py-3 rounded-md hover:bg-gray-50 transition-colors"
          >
            Contact Support
          </Link>
          <Link
            to="/dashboard"
            className="text-blue-600 px-8 py-3 hover:text-blue-700 transition-colors"
          >
            Back to Dashboard
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default PaymentCancelled;